import axios, { AxiosInstance } from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';
import { goAPIURL, mockAndDevelopment, productive } from 'src/app.config';

const goClient: AxiosInstance =
  productive() && mockAndDevelopment()
    ? axios.create()
    : axios.create({
        baseURL: goAPIURL(),
        headers: {
          accept: '*/*',
          'content-type': 'application/json',
        },
      });

export const mock =
  process.env.NODE_ENV !== 'production' && mockAndDevelopment()
    ? new AxiosMockAdapter(goClient, { delayResponse: 5 })
    : new AxiosMockAdapter(axios.create());

export default goClient;
